document.addEventListener('DOMContentLoaded', function () {
    const app = document.querySelector('.js-header');
    const btn = app.querySelector('.js-btn-nav');
    const menu = app.querySelector('.js-mobile-menu');
    const details = app.querySelectorAll('details');

    // Toggle nav visibility and close all details elements
    btn.addEventListener('click', function () {
        app.classList.toggle('is-nav');
        details.forEach((details) => {
            details.removeAttribute('open');
        });
    });

    // Close nav when clicking outside
    document.addEventListener('click', function (event) {
        if (!menu.contains(event.target) && !btn.contains(event.target)) {
            app.classList.remove('is-nav');
        }
    });

    // Event delegation for summary click
    document.body.addEventListener('click', function (event) {
        if (event.target.tagName.toLowerCase() === 'summary') {
            const detailsElement = event.target.parentElement;
            const contentElement = event.target.nextElementSibling;

            if (contentElement.classList.contains('animation')) {
                contentElement.classList.remove('animation', 'collapsing');
                void element.offsetWidth;
                return;
            }

            const onAnimationEnd = (cb) => contentElement.addEventListener('animationend', cb, { once: true });

            requestAnimationFrame(() => contentElement.classList.add('animation'));
            onAnimationEnd(() => contentElement.classList.remove('animation'));

            if (detailsElement.getAttribute('open') !== null) {
                event.preventDefault();
                contentElement.classList.add('collapsing');
                onAnimationEnd(() => {
                    detailsElement.removeAttribute('open');
                    contentElement.classList.remove('collapsing');
                });
            }
        }
    });

    const subMenus = document.querySelectorAll('.sub-menu');

    subMenus.forEach(function (subMenu) {
        let maxWidth = 0;

        const links = subMenu.querySelectorAll('li a');
        links.forEach(function (link) {
            const linkWidth = link.getBoundingClientRect().width;
            if (linkWidth > maxWidth) {
                maxWidth = linkWidth;
            }
        });

        subMenu.style.minWidth = `${maxWidth}px`;
    });

    // Debounce function for resize handler
    function debounce(func, wait = 100) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    function checkWindowSize() {
        if (window.innerWidth > 1024) {
            details.forEach((detailsElement) => {
                detailsElement.setAttribute('open', '');
            });
        } else {
            details.forEach((detailsElement) => {
                detailsElement.removeAttribute('open');
            });
        }
    }

    const debouncedCheckWindowSize = debounce(checkWindowSize);

    window.addEventListener('resize', debouncedCheckWindowSize);
    checkWindowSize(); // Initial check
});
